<template>
  <div>
    <router-link
      class="flex items-center justify-center bg-white px-5 py-3 text-base hover:bg-[color:var(--color-primary-500)] hover:text-white"
      :to="item.route ?? '#'"
      @click="select"
    >
      {{ item.title }}
    </router-link>
  </div>
</template>

<script setup lang="ts">
import type { ExtendedMenuLinkType } from "@/core/types";

interface IEmits {
  (event: "select"): void;
}

interface IProps {
  item: ExtendedMenuLinkType;
}

const emit = defineEmits<IEmits>();
defineProps<IProps>();

function select() {
  emit("select");
}
</script>

<style scoped lang="scss">
.catalog-menu-link {
  @apply mb-2 block px-2 py-1 text-base font-bold hover:bg-neutral-100;
}

.catalog-menu-child-link {
  @apply mb-1 block truncate px-2 py-1 text-sm leading-4 text-neutral hover:bg-neutral-100;
}
</style>
